"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAnnouncements = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_bootstrap_1 = require("react-bootstrap");
var use_mount_hook_1 = require("../../../api/hooks/use-mount.hook");
var context_1 = require("../../../api/context");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var DpAnnouncements_styled_1 = require("./DpAnnouncements.styled");
/**
 * DpAnnouncements
 */
var DpAnnouncements = function () {
    // ------------------------------ Context
    var announcementService = (0, react_1.useContext)(context_1.ServiceContext).announcementService;
    // ------------------------------ State
    var _a = (0, react_1.useState)(false), initialized = _a[0], setInitialized = _a[1];
    var _b = (0, react_1.useState)(), announcement = _b[0], setAnnouncement = _b[1];
    // ------------------------------ Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // ------------------------------ Methods
    var loadAnnouncement = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var latest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, announcementService.findLatest()];
                case 1:
                    latest = _a.sent();
                    setAnnouncement(latest);
                    setInitialized(true);
                    return [2 /*return*/];
            }
        });
    }); }, [announcementService, setAnnouncement, setInitialized]);
    var goToAnnouncement = (0, react_1.useCallback)(function () {
        if (announcement) {
            window.open(announcement.url, '_blank');
        }
    }, [announcement]);
    (0, use_mount_hook_1.useMount)(function () {
        loadAnnouncement();
    });
    // ------------------------------- Render
    return initialized ? ((0, jsx_runtime_1.jsx)(DpAnnouncements_styled_1.StyledAnnouncements, { className: "announcements", children: announcement !== undefined && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger, { overlay: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Tooltip, { id: "type-tooltip", children: t("announcements.whatIsNew") }), placement: "bottom", children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Button, { "aria-label": t("announcements.goToWhatIsNew"), className: "announcement-link border-0 btn-outline-primary", onClick: goToAnnouncement, children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { name: "megaphone-fill" }), !announcement.expired && (0, jsx_runtime_1.jsx)("div", { className: "not-expired" })] }) })) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.DpAnnouncements = DpAnnouncements;
exports.default = exports.DpAnnouncements;
